import StickySearchBar from '../shared/StickySearchBar';

const MoldListSkeleton = ({ viewMode = 'table' }) => {
  const skeletonArray = Array(5).fill(0);

  const TableSkeleton = () => (
    <div className="animate-pulse">
      {/* Header and tabs skeleton */}
      <div className="max-w-7xl mx-auto px-6">
        <div className="pt-8">
          <div className="h-8 w-48 bg-gray-200 rounded mb-3" />
        </div>

        {/* Tab buttons skeleton */}
        <div className="flex space-x-4 py-2">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="h-8 w-32 bg-gray-200 rounded" />
          ))}
        </div>

        {/* Table skeleton */}
        <div className="mt-6 overflow-x-auto">
          <div className="min-w-full divide-y divide-gray-200">
            {/* Table header */}
            <div className="bg-gray-50">
              <div className="grid grid-cols-7 gap-4 px-6 py-3">
                {[...Array(7)].map((_, i) => (
                  <div key={i} className="h-4 bg-gray-200 rounded" />
                ))}
              </div>
            </div>

            {/* Table body */}
            <div className="bg-white divide-y divide-gray-200">
              {skeletonArray.map((_, index) => (
                <div key={index} className="grid grid-cols-7 gap-4 px-6 py-4">
                  {[...Array(7)].map((_, i) => (
                    <div key={i} className="h-4 bg-gray-200 rounded" />
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Pagination skeleton */}
        <div className="flex justify-between items-center mt-4">
          <div className="h-4 w-48 bg-gray-200 rounded" />
          <div className="flex space-x-2 items-center">
            <div className="h-8 w-32 bg-gray-200 rounded" />
            <div className="h-8 w-32 bg-gray-200 rounded" />
          </div>
        </div>
      </div>
    </div>
  );

  const CardSkeleton = () => (
    <div className="animate-pulse">
      {/* Header and tabs skeleton */}
      <StickySearchBar 
        onSearch={() => {}} 
        onSearchFieldChange={() => {}} 
        showShadow={true} 
        enableScan={true} 
      />
      <div className="max-w-7xl mx-auto px-6">
        <div className="pt-8">
          <div className="h-8 w-48 rounded mb-3">
            <h1 className="text-2xl font-bold mb-3 w-full text-left">
              ทะเบียนแม่พิมพ์
            </h1>
          </div>
        </div>

        {/* Tab buttons skeleton */}
        <div className="flex space-x-4 py-2">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="h-8 w-32 bg-gray-200 rounded" />
          ))}
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
          {skeletonArray.map((_, index) => (
            <div key={index} className="bg-white rounded-lg shadow p-6">
              <div className="flex justify-between items-start mb-4">
                <div className="space-y-2">
                  <div className="h-4 w-32 bg-gray-200 rounded" />
                  <div className="h-4 w-24 bg-gray-200 rounded" />
                </div>
                <div className="h-8 w-8 bg-gray-200 rounded" />
              </div>
              <div className="space-y-4">
                <div className="h-4 w-full bg-gray-200 rounded" />
                <div className="h-4 w-3/4 bg-gray-200 rounded" />
                <div className="h-8 w-full bg-gray-200 rounded" />
              </div>
            </div>
          ))}
        </div>

        {/* Pagination skeleton */}
        <div className="flex justify-between items-center mt-4">
          <div className="h-4 w-48 bg-gray-200 rounded" />
          <div className="flex space-x-2 items-center">
            <div className="h-8 w-32 bg-gray-200 rounded" />
            <div className="h-8 w-32 bg-gray-200 rounded" />
          </div>
        </div>
      </div>
    </div>
  );

  return viewMode === 'table' ? <TableSkeleton /> : <CardSkeleton />;
};

export default MoldListSkeleton;
